<h2 mat-dialog-title>{{ "ai.fixWithAi" | translate }}</h2>

<mat-dialog-content class="dialogContainer">
  <div class="content">
    <!-- Loading -->
    @if (data.loading) {
      <div class="loadingContainer">
        <mat-spinner diameter="20"></mat-spinner>
        <p>{{ "ai.processing" | translate }}</p>
      </div>
    }
    <!-- Error -->
    @if (data.error && !data.loading) {
      <div class="errorContainer">
        <p>{{ data.error }}</p>
      </div>
    }

    <!-- Empty suggestion given. -->
    @if (
      !data.error && !data.loading && (!data.fields || !hasValidSuggestion)
    ) {
      <div class="emptySuggestion">
        <p>{{ "ai.noSuggestion" | translate }}</p>
      </div>
    } @else if (!data.loading && hasValidSuggestion) {
      <!-- All suggestion fields are valid. -->
      @for (field of data.fields; track field.title) {
        <div class="suggestionContainer">
          <!-- Only show the label if multiple fields exist. -->
          @if (data.fields.length > 1) {
            <label>{{ field.title }}</label>
          }
          <div class="suggestionContent dottedBorder">
            <p class="suggestionText">{{ field.value }}</p>
          </div>
        </div>
      }
    }
  </div>
  @if (!data.loading && hasValidSuggestion) {
    <div class="disclaimer">
      <p>{{ "ai.disclaimer" | translate }}</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    ca-action-button
    type="button"
    [mat-dialog-close]="false"
    class="cancel-button"
  >
    {{ "cancel" | translate }}
  </button>
  <button
    ca-action-button
    type="button"
    color="primary"
    [mat-dialog-close]="true"
    [disabled]="!hasValidSuggestion"
    class="accept-button"
  >
    {{ "ai.accept" | translate }}
  </button>
</mat-dialog-actions>
